import React from "react";
import './SignUp.css';

import signupbg from '../images/PageImg/SignUp-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'

function SignUp() {
  // console.log("get into SignUp()");
  return (
    <div className='signup-page'>
      <div className='signupheader'
        style={{ backgroundImage: `url(${signupbg})`, height: "auto" }} >
        <HeaderSlide text={'Sign Up'} />
      </div>
      {/* <header className='mt-5'> */}
      <br /> <br />
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <h1 className='text-dark'>Sign Up Content</h1>
      </div>
      {/* </header> */}
    </div>
  );
}

export default SignUp;